<template>
  <div class="main-page" :style="{ paddingTop: `${headerHeight}px` }">
    <ParallaxParticles v-if="!isMobileDevice" />
    <div v-if="!isMobileView" class="ghost-text">
      <slot name="ghost-text"></slot>
    </div>
    <div v-if="!isMobileView" class="orbits">
      <div
        v-for="(orbit, orbitKey) in imagesToOrbits"
        :key="orbitKey"
        class="ellipse"
      >
        <div
          v-for="(story, imageKey) in orbit"
          class="dot"
          :key="imageKey"
          :style="{ animationDelay: `${(0 + imageKey) * -12}s` }"
        >
          <div
            class="dot-inner"
            :style="{ animationDelay: `${(0 + imageKey) * -12}s` }"
          >
            <div
              class="image"
              :style="{ backgroundImage: `url(${story.image})` }"
            ></div>
            <div
              class="overlay"
              :style="{ animationDelay: `${(0 + imageKey) * -12}s` }"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="orbit-rows">
      <div
        v-for="(orbit, orbitKey) in imagesToOrbits"
        :key="orbitKey"
        class="orbitRow"
      >
        <div v-for="(story, imageKey) in orbit" class="dot" :key="imageKey">
          <div
            class="image"
            :style="{ backgroundImage: `url(${story.image})` }"
          ></div>
          <div class="overlay"></div>
        </div>
      </div>
    </div>
    <div class="text-content">
      <slot name="text-content"></slot>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import ParallaxParticles from "./ParallaxParticles";
export default {
  computed: {
    ...mapState(["stories", "isMobileDevice", "headerHeight"]),
    ...mapGetters(["isMobileView"]),
    imagesToOrbits() {
      let orbits = [];
      orbits.push(
        this.stories.filter((s, key) => key === 0 || key === 2 || key === 5)
      );
      orbits.push(
        this.stories.filter((s, key) => key === 9 || key === 10 || key === 11)
      );
      return orbits;
    },
  },
  mounted() {
    this.$store.commit("setHeaderWhite", false);
  },
  destroyed() {
    this.$store.commit("setHeaderWhite", true);
  },
  components: { ParallaxParticles },
};
</script>

<style lang="scss">
.main-page {
  height: 100%;
  font-family: "Open Sans", Arial;
  background: url("~@/assets/img/mainbg.jpg") no-repeat center;
  background-size: cover;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  will-change: transform;
  transition: transform 0s 0.7s;
  display: flex;
  align-items: center;
  justify-content: center;
  .text-content {
    text-align: center;
    max-width: 50vw;
    position: relative;

    h1 {
      color: #0055bb;
      margin-top: 0;
      margin-bottom: 80px;
    }
    h2 {
      font-weight: normal;
      color: #003274;
    }
    a.start {
      margin-top: 10px;
    }
  }
  .orbits {
    z-index: -1;
    .ellipse {
      display: block;
      position: absolute;
      top: 55%;
      left: 50%;
      width: 86vw;
      height: 86vw;
      border-radius: 50%;
      transform-origin: top left;
      &:first-of-type {
        transform: rotate(-70deg) scaleX(0.195) translate(-50%, -50%);
        .dot {
          .dot-inner {
            transform: rotate(70deg);
            animation: dotRotatingFirst 18s linear infinite;
          }
        }
      }
      &:nth-child(2) {
        transform: rotate(70deg) scaleX(0.195) translate(-50%, -50%);
        .dot {
          .dot-inner {
            transform: rotate(-70deg);
            animation: dotRotatingSecond 18s linear infinite;
          }
        }
      }
      &:before {
        content: "";
        position: absolute;
        top: 2%;
        left: 0;
        border: 3px dotted #5695cf;
        border-radius: 50%;
        width: 100%;
        height: 100%;
      }
      .dot {
        position: absolute;
        width: 190px;
        height: 140px;
        top: 50%;
        left: 50%;
        transform: translateX(-32vw) scaleX(5);
        animation: circle 50s linear infinite;
        will-change: transform;
        .dot-inner {
          position: absolute;
          width: 100%;
          height: 100%;
          will-change: transform;
          .image {
            position: relative;
            width: 100%;
            height: 100%;
            background-size: contain;
            background-position: center;
            background-color: #ffffff;
            background-repeat: no-repeat;
            border: 11px solid #fff;
            box-shadow: 2px 5px 14px 10px rgba(75, 91, 111, 0.1);
            &:before {
              content: "";
              top: -12px;
              left: -12px;
              position: absolute;
              width: 100%;
              height: 100%;
              transform: rotate(8deg);
              z-index: -1;
              background-color: #fff;
              border: 11px solid #fff;
              box-shadow: 2px 5px 14px 10px rgba(75, 91, 111, 0.1);
            }
            &:after {
              content: "";
              position: absolute;
              width: 28px;
              height: 28px;
              background-image: url("~@/assets/img/clip.png");
              background-repeat: no-repeat;
              background-size: contain;
              background-position: center;
              top: -17px;
              right: 0;
            }
          }
          .overlay {
            position: absolute;
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
            background-color: #fff;
            border: 11px solid #fff;
            opacity: 0.8;
            animation: dotOpacity 18s linear infinite;
          }
        }
      }
    }
  }
  .ghost-text {
    pointer-events: none;
    transition: 0.5s 0.5s;
    animation: ghost linear infinite;
    animation-direction: alternate;
    animation-duration: 30s;
    white-space: nowrap;
    @keyframes ghost {
      0% {
        transform: translate(-55%, 0);
      }
      25% {
        transform: translate(-50%, -20%);
      }
      50% {
        transform: translate(-45%, 0);
      }
      75% {
        transform: translate(-50%, 20%);
      }
      100% {
        transform: translate(-55%, 0);
      }
    }
  }
}
.mobile .main-page {
  height: 100%;
  margin-top: 0;
  padding-top: 120px;
}
#portrait {
  .main-page {
    .orbit-rows {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      .orbitRow {
        position: absolute;
        height: 70px;
        width: 100%;
        &:nth-child(1) {
          top: 90px;
        }
        &:nth-child(2) {
          bottom: 40px;
        }
        display: flex;
        justify-content: space-around;
        .dot {
          position: relative;
          display: inline-block;
          width: 90px;
          .image {
            position: relative;
            width: 100%;
            height: 100%;
            background-size: cover;
            background-repeat: no-repeat;
            border: 5px solid #fff;
            box-shadow: 0px 0px 4px 3px rgba(75, 91, 111, 0.1);
            &:before {
              content: "";
              top: -4px;
              left: -4px;
              position: absolute;
              width: 100%;
              height: 100%;
              transform: rotate(6deg);
              z-index: -1;
              background-color: #fff;
              border: 5px solid #fff;
              box-shadow: 2px 5px 14px 10px rgba(75, 91, 111, 0.1);
            }
            &:after {
              content: "";
              position: absolute;
              width: 18px;
              height: 18px;
              background-image: url("~@/assets/img/clip.png");
              background-repeat: no-repeat;
              background-size: contain;
              background-position: center;
              top: -9px;
              right: -3px;
            }
          }
          .overlay {
            position: absolute;
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
            background-color: #fff;
            border: 11px solid #fff;
            opacity: 0.5;
          }
        }
      }
    }
    .text-content {
      width: 100%;
      max-width: 100%;
      padding: 0 20px;
      margin-top: -50px;
    }
  }
  .slide.last-slide {
    .main-page {
      .orbit-rows {
        display: none;
      }
    }
  }
}
@keyframes circle {
  from {
    transform: rotate(0deg) translate3d(-43vw, 0, 0) rotate(0) scale(5, 1);
  }
  to {
    transform: rotate(360deg) translate3d(-43vw, 0, 0) rotate(-360deg)
      scale(5, 1);
  }
}
@keyframes dotRotatingFirst {
  0% {
    transform: rotate(70deg) scale(1, 1);
  }
  25% {
    transform: rotate(85deg) scale(1.5, 1.5);
  }
  50% {
    transform: rotate(70deg) scale(1, 1);
  }
  75% {
    transform: rotate(55deg) scale(1.5, 1.5);
  }
  100% {
    transform: rotate(70deg) scale(1, 1);
  }
}
@keyframes dotRotatingSecond {
  0% {
    transform: rotate(-70deg) scale(1, 1);
  }
  25% {
    transform: rotate(-85deg) scale(1.5, 1.5);
  }
  50% {
    transform: rotate(-70deg) scale(1, 1);
  }
  75% {
    transform: rotate(-55deg) scale(1.5, 1.5);
  }
  100% {
    transform: rotate(-70deg) scale(1, 1);
  }
}
@keyframes dotOpacity {
  0% {
    opacity: 0.8;
  }
  25% {
    opacity: 0;
  }
  50% {
    opacity: 0.8;
  }
  75% {
    opacity: 0;
  }
  100% {
    opacity: 0.8;
  }
}
@media only screen and (min-width: 1201px) {
  .main-page {
    h2 {
      font-size: 48px;
      line-height: 52px;
    }
  }
}
@media only screen and (max-width: 1200px) {
  .main-page {
    .text-content {
      h1 {
        margin-bottom: 40px;
      }
    }
    .orbits {
      .ellipse {
        .dot {
          position: absolute;
          width: 160px;
          height: 120px;
          .dot-inner {
            .image {
              border-width: 8px;
              &:before {
                border-width: 8px;
              }
            }
          }
        }
      }
    }
  }
}
@media only screen and (max-width: 1024px) {
  .main-page {
    .orbits {
      .ellipse {
        .dot {
          position: absolute;
          width: 100px;
          height: 80px;
          .dot-inner {
            .image {
              border-width: 6px;
              &:before {
                border-width: 6px;
              }
            }
          }
        }
      }
    }
  }
  .ghost-text {
    font-size: 120px;
  }
}
@media only screen and (max-width: 768px) {
  .main-page {
    .text-content {
      h1 {
        margin-bottom: 40px;
      }
    }
    .orbits {
      .ellipse {
        .dot {
          position: absolute;
          width: 72px;
          height: 60px;
          .dot-inner {
            .image {
              border-width: 4px;
              &:before {
                border-width: 4px;
              }
            }
          }
        }
      }
    }
  }
}
</style>